module.exports = __webpack_public_path__ + "5cf725bcec20ef8db3ba6d88249401c2.svg";